module.exports = __webpack_public_path__ + "images/emoji/two_women_holding_hands.756536ea741777b9117c.png";